/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject8 model module.
 * @module model/InlineObject8
 * @version 1.0.0
 */
class InlineObject8 {
    /**
     * Constructs a new <code>InlineObject8</code>.
     * @alias module:model/InlineObject8
     */
    constructor() { 
        
        InlineObject8.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineObject8</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject8} obj Optional instance to populate.
     * @return {module:model/InlineObject8} The populated <code>InlineObject8</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject8();

            if (data.hasOwnProperty('pue_certificate_id')) {
                obj['pue_certificate_id'] = ApiClient.convertToType(data['pue_certificate_id'], 'Number');
            }
            if (data.hasOwnProperty('attempt_id')) {
                obj['attempt_id'] = ApiClient.convertToType(data['attempt_id'], 'Number');
            }
            if (data.hasOwnProperty('event_id')) {
                obj['event_id'] = ApiClient.convertToType(data['event_id'], 'Number');
            }
            if (data.hasOwnProperty('event_calendar_id')) {
                obj['event_calendar_id'] = ApiClient.convertToType(data['event_calendar_id'], 'Number');
            }
            if (data.hasOwnProperty('formative_action_id')) {
                obj['formative_action_id'] = ApiClient.convertToType(data['formative_action_id'], 'Number');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} pue_certificate_id
 */
InlineObject8.prototype['pue_certificate_id'] = undefined;

/**
 * @member {Number} attempt_id
 */
InlineObject8.prototype['attempt_id'] = undefined;

/**
 * @member {Number} event_id
 */
InlineObject8.prototype['event_id'] = undefined;

/**
 * @member {Number} event_calendar_id
 */
InlineObject8.prototype['event_calendar_id'] = undefined;

/**
 * @member {Number} formative_action_id
 */
InlineObject8.prototype['formative_action_id'] = undefined;

/**
 * @member {Number} cost
 */
InlineObject8.prototype['cost'] = undefined;






export default InlineObject8;

